// api/api.js
import api from "../../axiosConfig";

export const getAllPOData = async (params) => {
  try {
    const response = await api.get("/po-home", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching PO data:", error);
    throw error;
  }
};

export const getPOExtractedInfo = async (filename) => {
  try {
    const response = await api.get(`/extracted-info/${filename}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching extracted PO data for ${filename}:`, error);
    throw error;
  }
};

export const updatePOData = async (payload) => {
  try {
    const response = await api.post("/update-entry", payload);
    return response.data;
  } catch (error) {
    console.error("Error updating PO data:", error);
    throw error;
  }
};

export const getCustomers = async () => {
  try {
    const response = await api.get("/get-customers");
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
};

export const getItemNames = async () => {
  try {
    const response = await api.get("/get-item-names");
    return response.data;
  } catch (error) {
    console.error("Error fetching item names:", error);
    throw error;
  }
};

export const getSkuCodes = async () => {
  try {
    const response = await api.get("/get-sku-codes");
    return response.data;
  } catch (error) {
    console.error("Error fetching SKU codes:", error);
    throw error;
  }
};

export const getSkuMaster = async () => {
  try {
    const response = await api.get("/get-sku-master");
    return response.data;
  } catch (error) {
    console.error("Error fetching SKU master:", error);
    throw error;
  }
};

export const updateSkuMapping = async ({ Platform, Item_Code, SD_Code }) => {
  try {
    const response = await api.post("/update-sku-mapping", {
      Platform,
      Item_Code,
      SD_Code,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating SKU mapping:", error);
    throw error;
  }
};

export const updateOutletMapping = async ({ Platform, Outlet_Code, Outlet_Address }) => {
  try {
    const response = await api.post("/update-outlet-mapping", {
      Platform,
      Outlet_Code,
      Outlet_Address,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating outlet mapping:", error);
    throw error;
  }
};

export const getDCNames = async () => {
  try {
    const response = await api.get("/get-dc-name-list");
    return response.data;
  } catch (error) {
    console.error("Error fetching item names:", error);
    throw error;
  }
};

export const searchOutletCode = async (query, platform) => {
  try {
    const response = await api.get("/search-outletcode", {
      params: { query, platform},
    });
    return response.data;
  } catch (error) {
    console.error("Outlet search error:", error);
    return [];
  }
};

